// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"navGroup_wrapper__rtZ9z","icon":"navGroup_icon__ILRHQ","labelWrapper":"navGroup_labelWrapper__FBxcR","arrow":"navGroup_arrow__zgF7S"};